import type { ReactNode } from "react";
import { BrandLogo, Card } from "../../shared/ds";
import "./auth.css";

/**
 * Signed-out screens (login, code, welcome, invite, errors) on the DS access pattern: one focused column with the
 * brand, the page title and the form in a single card (AccessScreens · sc-focused-flow / sc-auth-form).
 */
export function AuthLayout({ title, subtitle, children, footer }: { title: string; subtitle?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <main className="auth">
      <div className="sc-focused-flow auth-flow">
        <Card className="auth-card">
          <div className="sc-auth-form sc-stack">
            <BrandLogo />
            <header className="sc-heading">
              <div>
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
              </div>
            </header>
            {children}
          </div>
        </Card>
        {footer && <div className="auth-footer muted">{footer}</div>}
      </div>
    </main>
  );
}
